import * as constants from '../constants';

export const requestInstance = (id) => ({type: constants.INSTANCE_REQUESTED, payload: {id}});
export const instanceFailure = (id, error) => ({type: constants.INSTANCE_FAILURE, payload: {id, error}});
export const instanceSuccess = (id, instance) => ({type: constants.INSTANCE_SUCCESS, payload: {id, instance}});

export const requestPostInstance = (id, answers) => ({type: constants.INSTANCE_POST_REQUESTED, payload: {id, answers}});
export const instancePostFailure = (id, error) => ({type: constants.INSTANCE_POST_FAILURE, payload: {id, error}});
export const instancePostSuccess = (id, instance) => ({type: constants.INSTANCE_POST_SUCCESS, payload: {id, instance}});
